import { useEffect } from 'react';
import { isMac } from '@/shared/lib';

export function useCmdJ(open: () => void) {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      const isCmdK =
        (isMac && e.metaKey && e.key.toLowerCase() === 'j') || (!isMac && e.ctrlKey && e.key.toLowerCase() === 'j');
      if (isCmdK) {
        e.preventDefault();
        open();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open]);

  return { shortcut: isMac ? '⌘J' : 'ctrl+J' };
}
